<template>
  <div>
    <div class="container float-page">
      <!-- Float Box -->
      <div class="float-box">
        <!-- Float Card Body -->
        <div class="card">
          <div class="card-body float-card-body">
            <h1 class="mb-4">{{ $t('loginFun.certification.authentication') }}</h1>
            <el-form
              :model="messageModel"
              :rules="activerules"
              ref="messageModel"
            >
              <el-form-item label="" prop="email">
                <el-input
                  v-model="messageModel.email"
                  suffix-icon="el-icon-message"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="userName">
                <el-input
                  v-model="messageModel.userName"
                  suffix-icon="el-icon-user-solid"
                  :placeholder="$t('loginFun.certification.userName')"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="videoName">
                <el-input
                  v-model="messageModel.videoName"
                  :placeholder="$t('loginFun.certification.videoName')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('loginFun.certification.area')" prop="area">
                <el-select
                  v-model="messageModel.area"
                  clearable
                  :placeholder="$t('loginFun.certification.area_placeholder')"
                >
                  <el-option
                    v-for="Area in EventCityList"
                    :key="Area.name"
                    :label="Area.name"
                    :value="Area.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="" prop="telNum">
                <el-input
                  v-model="messageModel.telNum"
                  suffix-icon="el-icon-phone"
                  placeholder="電話號碼 (必須填寫正確號碼才能接收到驗證碼)"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="" prop="verificationCode">
                <div class="fx">
                  <div>
                    <el-input
                      v-model="messageModel.verificationCode"
                      :placeholder="$t('loginFun.certification.verificationCode')"
                    ></el-input>
                  </div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-block btn-primary btn-lg verbtn"
                      @click="getVer"
                      :disabled="count > 0"
                    >
                      {{ showText }}
                    </button>
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <div class="divCheck">
              <div class="row align-center mb-4">
                <div class="col-12">
                  <div class="icheck-primary">
                    <input type="checkbox" id="agreement" v-model="isCheck" />
                    <label for="agreement">
                       {{ $t('loginFun.certification.isCheck') }}
                      <router-link
                        target="_blank"
                        :to="{
                          name: 'certificationTerms',
                        }"
                        > {{ $t('loginFun.certification.certificationTerms') }}</router-link
                      >
                      {{ $t('loginFun.certification.or') }}
                      <router-link
                        target="_blank"
                        :to="{
                          name: 'copyright',
                        }"
                        > {{ $t('loginFun.certification.copyright') }}</router-link
                      >
                    </label>
                  </div>
                  <div class="icheck-primary">
                    <iframe class="cert-iframe" :src="iframeUrl"></iframe>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-block btn-primary btn-lg mt-3"
              @click="submitForm"
            >
              {{ $t('loginFun.certification.authentication') }}
            </button>
            <p class="ag-text" style="text-align: center">
           {{ $t('loginFun.certification.promise') }}
            </p>
          </div>
        </div>
        <!-- /.float-card-body -->
      </div>
      <!-- /.float box -->
    </div>

    <div id="alarmModal" class="modal">
      <div class="modal-content-sm">
        <span class="closebtn-sm" @click="closealarmModal">&times;</span>
        <p class="text-content-sm"> {{ $t('loginFun.certification.closealarmModal') }}</p>
        <div>
          <a href="javascript:void(0)" target="_self" :alt="$t('loginFun.certification.verify')" @click="go"
            ><div class="btn"> {{ $t('loginFun.certification.verify') }}</div></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import bases from "../../api/httpApi/base";
export default {
  data() {
    var validate1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請輸入影片名稱"));
      } else if (value.length > 6 || value.length < 2) {
        callback(new Error("長度在2到6個中英數字字符"));
      } else {
        callback();
      }
    };
    return {
      iframeUrl: "",
      EventCityList: [
        { name: "臺灣" },
        { name: "香港特別行政區" },
        { name: "澳門特別行政區" },
        { name: "中國大陸" },
        { name: "海外地區" },
      ],
      isCheck: false,
      showText: "獲取驗證碼",
      timer: null,
      count: 0,
      messageModel: {
        email: null,
        userName: "",
        area: null,
        telNum: "",
        verificationCode: "",
        videoName: "",
      },
      activerules: {
        email: [{ required: true, message: "郵箱不能為空", trigger: "blur" }],
        userName: [{ required: true, message: "請輸入姓名", trigger: "blur" }],
        videoName: [
          // { required: true, message: "請輸入影片號", trigger: "blur" },
          // { min: 2, max: 6, message: "长度在2到6个字符", trigger: "blur" },
          { validator: validate1, trigger: "blur" },
        ],
        area: [{ required: true, message: "請選擇地區", trigger: "change" }],
        telNum: [
          { required: true, message: "請輸入電話號碼", trigger: "blur" },
        ],
        verificationCode: [
          { required: true, message: "輸入驗證碼", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    //判断是否登陆
    if (this.CheckUserIsLogin()) {
      //判断是否已认证
      if (!this.loginUser.sgL_IsCheck) {
        this.iframeUrl = bases.evi + "/certificationTermsIframe";
        this.getUserInfo();
      } else {
        if (this.$route.query.redirect) {
          //如果存在参数
          let redirect = this.$route.query.redirect;
          this.$router.push(redirect); //则跳转至进入登录页前的路由
        } else {
          this.$router.push({ name: "Index" }); //否则跳转至首页
        }
      }
    }
  },
  methods: {
    isChn(str) {
      var reg = /^[\u4E00-\u9FA5]+$/;
      if (!reg.test(str)) {
        return false;
      } else {
        return true;
      }
    },
    go() {
      this.closealarmModal();
      if (this.$route.query.redirect) {
        //如果存在参数
        let redirect = this.$route.query.redirect;
        this.$router.push(redirect); //则跳转至进入登录页前的路由
      } else {
        this.$router.push({ name: "Index" }); //否则跳转至首页
      }
    },
    closealarmModal() {
      $("#alarmModal").modal("hide");
    },
    getUserInfo() {
      let params = {
        id: this.loginUser.userId,
      };
      this.$api.common.getCustomerModel(params).then((res) => {
        this.messageModel.email = res.data.result.sgL_LoginEmail;
        //this.messageModel.email = "1015503290@qq.com";
      });
    },
    getVer() {
      // //判断手机号是否为空
      // if (this.IsNullOrEmpty(this.messageModel.telNum)) {
      //   Message({
      //     type: "error",
      //     message: this.activerules.telNum[0].message,
      //   });
      //   return;
      // } else {
      //   var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      //   if (!myreg.test(this.messageModel.telNum)) {
      //     Message({
      //       type: "error",
      //       message: "電話號碼格式不正確",
      //     });
      //     return;
      //   }
      // }
      if (this.IsNullOrEmpty(this.messageModel.email)) {
        Message({
          type: "error",
          message: "郵箱不能為空",
        });
        return;
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        let params = {
          email: this.messageModel.email,
        };
        this.$api.common.SendAuthEmail(params).then((res) => {
          if (res.data.success) {
            //提示發送成功
            Message({ type: "success", message: "請查看電郵" });
          } else {
            Message({ type: "error", message: "未找到對應的郵箱賬戶" });
          }
        });
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          this.count--;
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.showText = `${this.count}s後重發`;
          } else {
            this.showText = `獲取驗證碼`;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      if (this.count == 0) {
        //this.getVerificationCode();
      }
    },
    submitForm() {
      this.$refs.messageModel.validate((valid) => {
        if (valid) {
          if (!this.isCheck) {
            Message({
              type: "warning",
              message: "請勾選我已閱讀及同意實名認證條款及著作權條款",
            });
            return;
          }
          let params = {
            sgL_LoginEmail: this.messageModel.email,
            sgL_MyVideoName: this.messageModel.videoName,
            sgL_CheckName: this.messageModel.userName,
            sgL_Area: this.messageModel.area,
            code: this.messageModel.verificationCode,
          };
          //添加
          this.$api.social.CheckName(params).then((result) => {
            if (result.data.success) {
              //this.loginUser.sgL_IsCheck = true;
              //刷新用户信息
              this.$store.commit("updateCheckStatus", true);
              sessionStorage.setItem(
                "store",
                JSON.stringify(this.$store.state)
              );
              localStorage.setItem(
                "userinfo",
                JSON.stringify(this.$store.state.customer)
              );
              $("#alarmModal").modal("show");
            } else {
              Message({
                type: "error",
                message: result.data.error.message,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.fx {
  display: flex;
}
.fx div:nth-child(1) {
  flex: 1;
}
.verbtn {
  margin-left: 5px;
}

.btn-primary {
  background-color: #26ad5e;
  border-color: #26ad5e;
}
.btn-primary:hover {
  background-color: #26ad5e;
  border-color: #26ad5e;
}

.divCheck {
  line-height: 1.5;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  word-wrap: break-word;
  word-break: break-all;
}
label {
  display: inline;
}

.modal-content-sm {
  background-color: #fefefe;
  margin: auto;
  border: 1px solid #888;
  width: 500px;
  height: 250px;
  display: revert;
  border-radius: 20px;
  margin-top: 10%;
}
.modal-content-sm div {
  text-align: center;
}

/* The Close Button */
.closebtn-sm {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  line-height: 0;
  padding: 25px 20px;
}

.text-content-sm {
  padding: 80px 0 50px 0;
  font-size: 16px;
  text-align: center;
}

.modal .btn {
  margin-left: initial;
  background-color: #26ad5e;
  font-size: 16px;
  color: #fff;
}

.modal .btn:active,
.modal .btn:hover {
  background-color: #1b7a43;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/login/certification.vue